module.exports = __webpack_public_path__ + "img/wishlist-1.b6d13d5.png";